<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide">
    <q-card :style="cardStyle" class="relative-position">
      <PDialogHeader :title="title" :closable="true" @close="onClose" />

      <q-card-section v-if="table">
        <PMarkupTable :columns="table.columns" :rows="table.data" />
      </q-card-section>

      <q-card-section v-if="label || text || htmlContent" :class="labelClass">
        <span v-if="htmlContent" v-html="htmlContent"></span>

        <span class="text-md text-neutral text-weight-medium q-px-md">
          {{ text }}
        </span>

        <p
          v-if="label"
          class="text-md text-neutral-80 text-weight-regular q-px-md"
        >
          {{ label }}
        </p>
      </q-card-section>

      <footer
        v-if="isFooterVisible"
        class="rounded-borders text-neutral-90 text-center"
      >
        <div class="q-py-xxl row items-center justify-end">
          <PBtn
            v-if="cancellable"
            :fluid="false"
            :label="cancelLabel"
            :style="{ marginInline: '3rem 1rem' }"
            type="cancel"
            outline
            @click="onCancel"
          />

          <PBtn
            v-if="submittable"
            :fluid="false"
            :loading="loading"
            :label="submitLabel"
            :style="{ marginInlineEnd: '3rem' }"
            type="submit"
            @click="onSubmit"
          />
        </div>
      </footer>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { useDialogPluginComponent } from "quasar";

const emit = defineEmits([
  ...useDialogPluginComponent.emits,
  "confirm",
  "close",
  "cancel",
]);

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } =
  useDialogPluginComponent();

defineProps({
  title: {
    type: String,
    default: "",
  },
  text: {
    type: String,
    default: "",
  },
  htmlContent: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  isFooterVisible: {
    type: Boolean,
    default: true,
  },
  cancellable: {
    type: Boolean,
    default: true,
  },
  cancelLabel: {
    type: String,
    default: "No",
  },
  submitLabel: {
    type: String,
    default: "Yes",
  },
  submittable: {
    type: Boolean,
    default: true,
  },
  loading: {
    type: Object,
    default: () => {},
  },
  closable: {
    type: Boolean,
    default: true,
  },
  labelClass: {
    type: String,
    default: "text-center q-ma-xl bg-surface rounded-borders",
  },
  table: {
    type: Object,
    default: () => {},
  },
  cardStyle: {
    type: Object,
    default: () => {
      return { minWidth: "auto" };
    },
  },
});

const onClose = async () => {
  emit("close");

  onDialogHide();
};

const onCancel = async () => {
  emit("cancel");

  onDialogCancel();
};

const onSubmit = async () => {
  emit("confirm");

  onDialogOK();
};
</script>
